import React from "react";
import Footer from "../common/Footer/FooterThree";
import Menu from "../common/Menu/Menu";
import Feature from "./Feature";
import Testimonial from "../common/Testimonial/Testimonial";
import Brands from "../common/Brands/Brands";
import LastedBlog from "./LastedBlog";
import FullScreenBtn from "../common/FullScreenBtn";
import TopAbout from "./TopAbout";
import TopCategoryHomePageTwo from"./TopCategoryHomePageTwo";
import TopCtaArea from "./TopCtaArea";
import HomeSlider from "./HomeSlider";

const Home = () => {
  return (
    <>
      <Menu />
      <HomeSlider />
      <TopAbout />
      <TopCategoryHomePageTwo />
      <TopCtaArea />
      <Feature />
      <Testimonial />
      <Brands />
      <LastedBlog />
      <FullScreenBtn />
      <Footer />
    </>
  );
};

export default Home;
